import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  About,
  Activities,
  Contact,
  Error,
  Home,
  Lessons,
  SingleLesson,
  Services,
  Register,
  Login,
  ProtectedRoute,
} from './pages';
import {
  AllLessons,
  Profile,
  AdminHome,
  AddLesson,
  Dashboard,
} from './pages/dashboard';
import { UserNavbar, UserSidebar } from './components/NavBar';
import { Footer } from './components';

function App() {
  return (
    <Router>
      <UserNavbar />
      <UserSidebar />
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route
          path='auth'
          element={
            <ProtectedRoute>
              <AdminHome />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminHome />} />
          <Route path='alllessons' element={<AllLessons />} />
          <Route path='addlesson' element={<AddLesson />} />
          <Route path='profile' element={<Profile />} />
        </Route>
        <Route exact path='about' element={<About />} />
        <Route exact path='activiteiten' element={<Activities />} />
        <Route exact path='contact' element={<Contact />} />
        <Route exact path='lessen/' element={<Lessons />} />
        <Route exact path='lessen/:type' element={<SingleLesson />} />
        <Route exact path='services' element={<Services />} />
        <Route exact path='register' element={<Register />} />
        <Route exact path='login' element={<Login />} />
        <Route path='*' element={<Error />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
